import attViewerAudioView from './attViewerAudioComponent.html';
import './attViewerAudioComponent.css';

export function attViewerAudioComponent() {
	return {
		bindings: {
			attachment: '<',
		},
		controllerAs: 'vm',
		controller: attViewerAudioComponentCtrl,
		template: attViewerAudioView,
	};
}

export class attViewerAudioComponentCtrl {
	showError() {
		this.error = 'Error playing audio; your browser may not support this format. Please download the file to play it.';
	}
}
